import React from "react";
import "../styles/crm-product.css";
import { CrmHeroSection } from "../components/crm/CrmHeroSection";
import { CrmCommandCenterSection } from "../components/crm/CrmCommandCenterSection";
import { CrmLeadSection } from "../components/crm/CrmLeadSection";
import { CrmContactSection } from "../components/crm/CrmContactSection";
import { CrmPipelineSection } from "../components/crm/CrmPipelineSection";
import { CrmWhatsAppSection } from "../components/crm/CrmWhatsAppSection";
import { CrmMobileSection } from "../components/crm/CrmMobileSection";
import { CrmAnalyticsSection } from "../components/crm/CrmAnalyticsSection";
import { CrmBusinessImpactSection } from "../components/crm/CrmBusinessImpactSection";
import { CrmFaqSection } from "../components/crm/CrmFaqSection";
import { CrmFinalCtaSection } from "../components/crm/CrmFinalCtaSection";

export const HonestiCRMPage = () => (
    <div className="crm-product-page">
        <CrmHeroSection />
        <CrmCommandCenterSection />
        <CrmLeadSection />
        <CrmContactSection />
        <CrmPipelineSection />
        <CrmWhatsAppSection />
        <CrmMobileSection />
        <CrmAnalyticsSection />
        <CrmBusinessImpactSection />
        <CrmFaqSection />
        <CrmFinalCtaSection />
    </div>
);
